var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":"","md4":"","offset-md4":""}},[_c('v-img',{attrs:{"src":_vm.logoUrl}})],1),_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":"","md4":"","offset-md4":""}},[_c('elac-login')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }